module.exports = __webpack_public_path__ + "img/local_cloud_icon.50b37f81.svg";